import {useRequireAuth} from "@/entities/session";
import {Button} from "@/shared/ui/Button";
import {useModalStore} from "@/Stores/Site/ModalStore"; // Legacy

type Props = {
    productId: number;
    reviewAdd: boolean;
    className?: string;
};

export const AddReviewButton = ({productId, reviewAdd, className}: Props) => {
    const requireAuth = useRequireAuth();
    const openModalWriteReview = useModalStore(state => state.openModalWriteReview);

    if (!reviewAdd) {
        return null;
    }

    return (
        <Button
            className={className}
            onClick={() => requireAuth(() => openModalWriteReview(productId))}
            fullWidth
        >
            Оставить отзыв
        </Button>
    );
}
